import React, { useRef, useState, useEffect } from 'react';

export const PageBlock = ({ title, text, video, afterImageText, afterImageTitle, href, background }) => {
  const videoRef = useRef(null);
  const [ended, setEnded] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !ended) {
            video.play();
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(video);

    return () => {
      observer.disconnect();
    };
  }, [ended]);

  const handleEnded = () => {
    const video = videoRef.current;
    if (video) {
      video.pause();
      video.currentTime = video.duration; // stay at last frame
    }
    setEnded(true);
  };

  return (
    <div style={{background, color: background === 'white' ? '#25242D' : 'white', overflow: 'hidden'}}>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', gap: '16px', padding: '24px'}}>
        <div style={{textAlign: 'left', fontWeight: 400, fontStyle: 'bold', fontSize: '24px' }}>
          {title}
        </div>
        <div style={{textAlign: 'left', fontSize: '16px', lineHeight: '20px'}}>
          {text}
        </div>
      </div>
      <div>
        <video
          ref={videoRef}
          src={video}
          width="100%"
          muted
          playsInline
          preload='auto'
          onEnded={handleEnded}
        />
      </div>
      <div style={{position: 'relative', color: '#25242D'}}>
        <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', gap: '16px', padding: '24px', position: 'relative', top: '-32px', left: '24px', background: 'white', paddingRight: '48px'}}>
          <div style={{textAlign: 'left', fontWeight: 700, fontStyle: 'bold', fontSize: '24px' }}>
            {afterImageTitle}
          </div>
          <div style={{textAlign: 'left', fontSize: '16px', lineHeight: '20px'}}>
            {afterImageText}
          </div>
          <div style={{textAlign: 'left', fontWeight: 700, fontStyle: 'bold', fontSize: '16px', marginTop: '16px' }}>
            <a href={href} target="_blank" rel="noreferrer" reel style={{color: '#25242D', display: 'flex', alignItems: 'center'}}>
              <span style={{marginRight: '6px'}}>Get inspired</span>
              <svg width="12px" height="12px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="#25242D">
                <path d="M14 2H5.50003L4.00003 3.5L6.83581 6.33579L0.585815 12.5858L3.41424 15.4142L9.66424 9.16421L12.5 12L14 10.5L14 2Z" fill="#25242D" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}